<template>
  <div class="about">
    <HeaderNav :lmid="26" />
    <Banner :msg="26" />

    <div class="maodian" id="about1" ref="about1"></div>

    <section class="About_01">
      <div class="w1520 p95 p95_">
        <div class="box flexBetween">
          <div class="boxLeft">
            <div class="homeTitle wow animate__animated animate__fadeInUp">
              <div class="f60">
                <span>{{ about_01.englist_name }}</span
                >&nbsp;<em class="f48">{{ about_01.typename }}</em>
              </div>
            </div>
            <div
              class="content1 l_scrolly wow animate__animated animate__fadeInUp"
              v-html="about_01_list.desc"
            ></div>
            <div
              class="content2 flexBetween wow animate__animated animate__fadeInUp"
            >
              <div class="item">
                <div class="top">
                  <span id="target1">{{ about_01_list.scjy }}</span> 年
                </div>
                <div class="bot">生产经验</div>
              </div>
              <div class="item">
                <div class="top">
                  <span id="target2">{{ about_01_list.fmzl }}</span> 项
                </div>
                <div class="bot">发明专利</div>
              </div>
              <div class="item">
                <div class="top">
                  <span id="target3">{{ about_01_list.scscnl }}</span> 吨
                </div>
                <div class="bot">年生产能力</div>
              </div>
            </div>
          </div>
          <div class="boxRight">
            <p class="wow animate__animated animate__fadeInUp">
              <img :src="about_01_list.img" alt="" />
            </p>
          </div>
        </div>
      </div>
    </section>
    <div class="maodian" id="about2" ref="about2"></div>
    <section class="About_02">
      <div class="w1520 p95_">
        <div class="box flexBetween">
          <div class="images">
            <p class="wow animate__animated animate__fadeInUp">
              <img src="@/assets/images/img15.jpg" alt="" />
            </p>
          </div>

          <div class="banner1 wow animate__animated animate__fadeInUp">
            <div class="swiper-container swiper-no-swiping">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in about_02_list"
                  :key="index"
                >
                  <div class="content1">{{ item.title }}</div>
                  <div class="content2">{{ item.desc }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="banner2 wow animate__animated animate__fadeInUp">
            <div class="swiper-container swiper-no-swiping">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in about_02_list"
                  :key="index"
                >
                  <p>{{ item.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box1 m54">
          <div class="page">
            <div></div>
          </div>
        </div>
      </div>
    </section>
    <div class="maodian" id="about3" ref="about3"></div>
    <section class="About_03">
      <div class="p95 p95_">
        <div class="w1520">
          <div class="homeTitle wow animate__animated animate__fadeInUp">
            <div class="f60">
              <span>{{ about_03.englist_name }}</span
              >&nbsp;<em class="f48">{{ about_03.typename }}</em>
            </div>
          </div>
        </div>
        <div class="box m54">
          <div class="banner wow animate__animated animate__fadeInUp">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in about_03_list"
                  :key="index"
                >
                  <div>
                    <figure>
                      <img :src="item.img" alt="" />
                    </figure>
                    <div class="tit">{{ item.title }}</div>
                    <div class="dw">授予单位</div>
                    <div class="xh">{{ item.sydw }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box1 m54">
          <div class="page">
            <div></div>
          </div>
        </div>
      </div>
    </section>
    <div class="maodian" id="about4" ref="about4"></div>
    <section class="About_04">
      <div class="p95 p95_">
        <div class="w1520">
          <div class="homeTitle wow animate__animated animate__fadeInUp">
            <div class="f60">
              <span>{{ about_04.englist_name }}</span
              >&nbsp;<em class="f48">{{ about_04.typename }}</em>
            </div>
          </div>
          <div class="box m54">
            <div
              class="item wow animate__animated animate__fadeInUp"
              v-for="(item, index) in about_04_list"
              :key="index"
            >
              <img :src="item" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

import { CountUp } from "countup.js";
export default {
  name: "About",
  data() {
    return {
      about_01: {},
      about_01_list: {},
      about_02: {},
      about_02_list: [],
      about_03: {},
      about_03_list: [],
      about_04: {},
      about_04_list: [],
    };
  },
  beforeMount() {
    this.about_result();
    // this.$route.query.id
  },
  mounted() {
    // 创建实例  循环调用 所有 dom
    const io = new IntersectionObserver((entries) => {
      this.dg_();
    });
    // 获取所有 countToWrapper 标签 开始观察
    const countToWrapper = document.querySelector("#target1");
    io.observe(countToWrapper);
  },
  methods: {
    about_banner() {
      var Swiper2 = new Swiper(".About_02 .banner2 .swiper-container", {
        loop: true,
        speed: 1000,
        direction: "vertical",
        slidesPerView: 9,
        spaceBetween: 0,
        mousewheel: true,
        observer: true,
        observeParents: true,
        noSwiping: true,
        centeredSlides: true,
        on: {
          tap: function () {
            let initIndex =
              this.clickedIndex - this.activeIndex + this.realIndex;
          },
        },
      });

      var Swiper1;

      if (lpkWidth > 1024) {
        Swiper1 = new Swiper(".About_02 .banner1 .swiper-container", {
          loop: true,
          speed: 1000,
          direction: "vertical",
          slidesPerView: "auto",
          spaceBetween: 0,
          mousewheel: true,
          observer: true,
          observeParents: true,
          noSwiping: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          on: {
            slideChange: function () {
              let ind = this.realIndex;
              Swiper2.slideToLoop(ind, 1000, false);
              this.emit("transitionEnd");
            },
          },
        });
      } else {
        Swiper1 = new Swiper(".About_02 .banner1 .swiper-container", {
          loop: true,
          speed: 800,
          slidesPerView: 1,
          spaceBetween: 0,
          observer: true,
          observeParents: true,
          noSwiping: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".About_02 .page div",
            clickable: true,
          },
        });
      }

      Swiper2.on("slideChange", function () {
        let ind = this.realIndex;
        Swiper1.slideToLoop(ind, 1000, false);
      });

      new Swiper(".About_03 .banner .swiper-container", {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 800,
        spaceBetween: 30,
        slidesPerView: "auto",
        pagination: {
          el: ".About_03 .page div",
          clickable: true,
        },
        breakpoints: {
          1200: { spaceBetween: 30 },
          500: { spaceBetween: 20 },
          320: { spaceBetween: 10 },
        },
      });
    },
    async about_result() {
      let that = this;
      await this.$httpPost("/about", {})
        .then((res) => {
          that.about_01 = res[0];
          that.about_01_list = res[0].list[0];
          that.about_02 = res[1];
          that.about_02_list = res[1].list;
          that.about_03 = res[2];
          that.about_03_list = res[2].list;
          that.about_04 = res[3];
          that.about_04_list = res[3].list[0].imgs;
        })
        .catch((error) => {
          console.log(error);
        });

      this.$nextTick(() => {
        this.about_banner();
      });
    },
    ScrollIntoView(hash) {
      document.querySelector(hash).scrollIntoView();
    },
    dg_() {
      let demo1 = new CountUp("target1", this.about_01_list.scjy);
      demo1.start();
      let demo2 = new CountUp("target2", this.about_01_list.fmzl);
      demo2.start();
      let demo3 = new CountUp("target3", Number(this.about_01_list.scscnl));
      demo3.start();
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        this.$nextTick(() => {
          if (this.$route.hash != "") {
            setTimeout(() => {
              this.ScrollIntoView(this.$route.hash);
            }, 800);
          }
        });
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
